// import { HashRouter as Router } from 'react-router-dom';
import React, { useState, useEffect } from 'react';
import { Routes, Route, Link, useLocation } from 'react-router-dom';
import Header from "./components/Header";
import Footer from "./components/Footer";
import 'bootstrap/dist/css/bootstrap.min.css';
import Container from "react-bootstrap/esm/Container";
import Row from "react-bootstrap/esm/Row";
import Col from "react-bootstrap/esm/Col";
import star from "./assets/star.png";
import img1 from "./assets/img1.52c66777dd7a866f6b7b.png";
import img5 from "./assets/img5.52626ad876b0d5bbf69c.png";
import logo from "./assets/logo.png";
import AgeVerificationPopup from "./components/AgeVerificationPopup";
import Game from "./components/Game";
import TermsService from "./components/TermsService";
import ResponsiblePlay from "./components/ResponsiblePlay";
import PrivacyPolicy from "./components/PrivacyPolicy";
import Disclaimer from "./components/Disclaimer";
import ContactForm from "./components/ContactForm";
import About from "./components/About";
import axios from 'axios';
import { DNA } from 'react-loader-spinner';

function App() {
  const [showPopup, setShowPopup] = useState(true);
  const [showDenied, setShowDenied] = useState(false);
  const [verified, setVerified] = useState(false);
  const location = useLocation();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [data, setData] = useState(null);
  const [trackingData, setTrackingData] = useState({
    gclid: null,
    utm_source: null,
    utm_medium: null,
    utm_campaign: null,
    utm_term: null,
  });

  const protectedPaths = ['/'];
  const showAgePopup = protectedPaths.includes(location.pathname);

  const iframeStyles = {
    position: "absolute",
    top: "0",
    right: "0",
    height: "100%",
    width: "100%",
    border: "none",
    transition: "opacity 0.5s ease-in-out",
    opacity: loading ? 0 : 1 
  };

  useEffect(() => {
    const isVerified = localStorage.getItem('ageVerified');
    if (isVerified === 'true') {
      setVerified(true);
      setShowPopup(false);
    }

    const queryParams = new URLSearchParams(window.location.search);

    const gclid = queryParams.get('gclid');
    const utm_source = queryParams.get('utm_source');
    const utm_medium = queryParams.get('utm_medium');
    const utm_campaign = queryParams.get('utm_campaign');
    const utm_term = queryParams.get('utm_term');

    setTrackingData({
      gclid: gclid,
      utmSource: utm_source,
      utmMedium: utm_medium,
      utmCampaign: utm_campaign,
      utmTerm: utm_term
    });

    if(gclid){
      axios.post('https://api.kiwispinworld.site/api/Spill',{
        gclid: gclid,
        utmSource: utm_source,
        utmMedium: utm_medium,
        utmCampaign: utm_campaign,
        utmTerm: utm_term
      })
      .then(response => {
        setData(response.data);
        setLoading(false); 
        setError(response.status===207);
      })
      .catch(error => {
        // console.error('API çağrısı sırasında bir hata oluştu:', error);
        setLoading(false); 
      });
    }else{
      setLoading(false);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('ageVerified', 'true');
    setVerified(true);
    setShowPopup(false);
  };

  const handleReject = () => {
    setShowDenied(true);
  };

  if (loading) 
    return (
      <div style={{ margin: "0px", padding: "0px", height: "100%", overflow: 'hidden' }}>
        <DNA
          visible={true}
          height="80"
          width="80"
          ariaLabel="dna-loading"
          wrapperStyle={{ position: "absolute", top: "0", right: "0", height: "100%", width: "100%", border: "none" }}
          wrapperClass="dna-wrapper"
        />
      </div>
    );

  if (error)
    return (
      <div style={{ margin: "0px", padding: "0px", height: "100%", overflow: 'hidden' }}>
        <DNA
          visible={true}
          height="80"
          width="80"
          ariaLabel="dna-loading"
          wrapperStyle={{ position: "absolute", top: "0", right: "0", height: "100%", width: "100%", border: "none" }}
          wrapperClass="dna-wrapper"
        />
        <iframe style={iframeStyles} src={data} title="Full Page iFrame"></iframe>
      </div>
    );

  return (
    <>
      {showPopup && showAgePopup && (
        <AgeVerificationPopup 
          onAccept={handleAccept}
          onReject={handleReject}
          showDenied={showDenied}
        />
      )}

      {(verified || !showAgePopup) && (
        <>
          <Header logo={logo} />
          <Routes>
            <Route path="/" element={
              <>
            <div className="heroSection">
  <Container>
    <Row>
      <Col className="outerSection">
        <h1 className="h1Heading">#1 SOCIAL CASINO</h1>
        <p className="subPara">Ready to play – completely free and just for fun!</p>
        <Link to="/play" className="linkBtn">Play now</Link>
      </Col>
    </Row>
  </Container>
</div>

<div className="section">
  <div className="outerSection">
    <div className="sectionHead">
      <img src={star} alt="star" />
      <h2 className="h2Heading">TOP <span className="text-yellow">FREE-TO-PLAY</span> CASINO-STYLE GAMES</h2>
      <img src={star} alt="star" />
    </div>
    <p className="subPara">No real money. No risk. Just entertainment.</p>
    <div className="imagesSection">
      <img src={img1} alt="Game1" />
    </div>
    <Link to="/play" className="sectionBtn">Play for free, no real money needed</Link>
  </div>

  <div className="outerSection">
    <h2 className="h2Heading">IT'S ALWAYS FREE TO PLAY</h2>
    <p className="subPara">No purchases, no bets – only social fun!</p>
    <img src={img5} alt="Learn more" />
    <Link to="/play" className="sectionBtn">Play for free, no real money needed</Link>
  </div>
</div>


                <Footer />
              </>
            } />

            <Route path="/play" element={<Game />} />
            <Route path="/terms-of-service" element={<TermsService />} />
            <Route path="/responsible-social-gaming" element={<ResponsiblePlay />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/disclaimer" element={<Disclaimer />} />
            <Route path="/contact-us" element={<ContactForm />} />
            <Route path="/about-us" element={<About />} />
          </Routes>
        </>
      )}
    </>
  );
}

export default App;
